import { produce } from "immer";
import {
  GET_PRE_DATA,
  GET_PRE_DATA_SUCCESS,
  GET_PRE_DATA_FAILURE,
  //
  SAVE_PRE,
  SAVE_PRE_SUCCESS,
  SAVE_PRE_FAILURE,
  //
  TOGGLE_PRE_MODAL,
} from "./constants";

export const initialState = {
  isFetching: false,
  isSubmitting: false,
  preData: {},
  preModal: {
    open: false,
  },
};

const PreReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case GET_PRE_DATA:
        draft.isFetching = true;
        draft.preData = {};
        break;
      case GET_PRE_DATA_SUCCESS:
        draft.isFetching = false;
        draft.preData = action.payload;
        break;
      case GET_PRE_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Save
      case SAVE_PRE:
        draft.isSubmitting = true;
        break;
      case SAVE_PRE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case SAVE_PRE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Toggle Modal
      case TOGGLE_PRE_MODAL:
        draft.preModal = action.payload;
        break;

      default:
        return state;
    }
  });

export default PreReducer;
